module.exports = __webpack_public_path__ + "fonts/Lato-BoldItalic.71e8fd8e.ttf";